import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { PermissionService } from 'app/services/permission.service';
import { ToastService } from 'app/services/toast.service';
import { UrlPermissionMappingService } from 'app/services/url-permission-mapping.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
    constructor(
        private _permissionService: PermissionService,
        private _toastService: ToastService,
        private _urlMappingService: UrlPermissionMappingService,
        private _router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        // Check if URL should be excluded from permission checking
        if (this._urlMappingService.isExcludedUrl(state.url)) {
            return true;
        }

        const anyModuleIds: number[] | undefined = route.data['anyModuleIds'];
        if (anyModuleIds?.length) {
            if (anyModuleIds.some(id => this._permissionService.hasPermission(id, route.data['requiredPermission'] || 'View'))) return true;
            this._toastService.error("You don't have permission for it");
            this._router.navigate(['/dashboard']);
            return false;
        }

        // First check if route has explicit data (for custom cases)
        let moduleId = route.data['moduleId'];
        let requiredPermission = route.data['requiredPermission'];

        // If no explicit data, use URL mapping
        if (!moduleId) {
            const mapping = this._urlMappingService.getPermissionForUrl(
                state.url
            );
            if (mapping) {
                moduleId = mapping.moduleId;
                requiredPermission = mapping.requiredPermission;
            }
        }

        // If we have a moduleId, check permissions
        if (moduleId) {
            const hasPermission = this._permissionService.hasPermission(
                moduleId,
                requiredPermission || 'View'
            );

            if (!hasPermission) {
                // Show toast message
                this._toastService.error("You don't have permission for it");

                // Redirect to dashboard
                this._router.navigate(['/dashboard']);
                return false;
            }
        }

        return true;
    }
}
